/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useSearchParams } from 'react-router';

import { CreateAccountForm } from './CreateAccountForm';
import { VerifyEmailForm } from './VerifyEmailForm';
import { SetPasswordForm } from './SetPasswordForm';
import { useAuthModalsContext } from '../AuthModalContext';
import { CloseModalConfirmation } from './CloseModalConfirmation';
import { PasswordSavedSuccess } from '../components/PasswordSavedSuccess';

export function NewAccountForms() {
    const { isCloseConfirmationOpen, setIsCloseConfirmationOpen, closeModal, setScreen } =
        useAuthModalsContext();
    const [searchParams, setSearchParams] = useSearchParams();

    const authStep = searchParams.get('authStep');
    const emailAddress = searchParams.get('authEmail');

    const onEmailSent = (email: string) => {
        setSearchParams((prev) => {
            prev.set('auth', 'createAccount');
            prev.set('authStep', 'verify');
            prev.set('authEmail', email);
            return prev;
        });
    };

    const onEmailVerified = () => {
        setSearchParams((prev) => {
            prev.set('authStep', 'set-password');
            return prev;
        });
    };

    const transitionToSuccessScreen = () => {
        setSearchParams((prev) => {
            prev.set('authStep', 'success');
            prev.delete('authEmail');
            return prev;
        });
    };

    const transitionToLoginScreen = () => {
        setSearchParams((prev) => {
            prev.delete('auth');
            prev.delete('authStep');
            prev.delete('authEmail');
            return prev;
        });
        setScreen('login');
    };

    return (
        <>
            <div aria-hidden={isCloseConfirmationOpen}>
                {authStep === 'verify' && emailAddress ? (
                    // authStep 2
                    <VerifyEmailForm
                        emailAddress={emailAddress}
                        onEmailVerified={onEmailVerified}
                    />
                ) : authStep === 'set-password' ? (
                    // authStep 3
                    <SetPasswordForm
                        transitionToSuccessScreen={transitionToSuccessScreen}
                    />
                ) : authStep === 'success' ? (
                    // authStep 4
                    <PasswordSavedSuccess
                        transitionToLoginScreen={transitionToLoginScreen}
                    />
                ) : (
                    // authStep 1
                    <CreateAccountForm goToEmailVerification={onEmailSent} />
                )}
            </div>

            {authStep ? (
                <CloseModalConfirmation
                    isOpen={isCloseConfirmationOpen}
                    onAbortCloseClick={() => setIsCloseConfirmationOpen(false)}
                    onCloseClick={closeModal}
                />
            ) : null}
        </>
    );
}
